"use client";

import { captureEvent } from "@/app/_analytics/analytics";
import { EventName } from "@mw/shared/analyticsEventNames";

import { ImageVideoHero, type HeroDemoProps } from "../demos/ImageVideoHero/ImageVideoHero";

/**
 * Wraps the (non-interactive) image/video showcase with passive click tracking so the control arm
 * of the MW Image Interactive Hero experiment records the same `mw_image_hero_clicked` engagement
 * event as the interactive test hero — letting us compare click intent across arms even though the
 * showcase itself can't be clicked. The handler sits on a `display: contents` wrapper so it catches
 * bubbled clicks while staying layout-neutral; it's analytics-only (a passive sensor, not an
 * interactive control), so it adds no a11y semantics and never interferes with the demo.
 */
export function ImageVideoHeroTracked(props: HeroDemoProps) {
  return (
    <div className='tw-contents' onClick={() => captureEvent(EventName.mw_image_hero_clicked, { interactive: false })}>
      <ImageVideoHero {...props} />
    </div>
  );
}
